import WebConstant from "../../webConstants";
import { mainWrapper } from "../../main";


function patientCasesList(params) {
    return mainWrapper.get(WebConstant.host + "/case_list", params);
};


function patientCasesDetails(id) {
    return mainWrapper.get(WebConstant.host + `/patient/${id}`);
};


function patientCasesCreate(params) {
    return mainWrapper.post(WebConstant.host + `/patient`, params);
};


function patientCasesUpdate(id) {
    return mainWrapper.put(WebConstant.host + `/patient/${id}`,);
};


function patientCasesDelete(id) {
    return mainWrapper._delete(WebConstant.host + `/patient/${id}`);
};


export const patientCasesServices = {
    patientCasesList,
    patientCasesDetails,
    patientCasesCreate,
    patientCasesUpdate,
    patientCasesDelete,
};
